import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FiX, FiAlertCircle } from 'react-icons/fi';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

const SnackbarContainer = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  min-width: 300px;
  max-width: 500px;
  background: #dc3545;
  color: white;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: ${props => props.closing ? slideDown : slideUp} 0.3s ease forwards;

  @media (max-width: 768px) {
    min-width: auto;
    width: calc(100% - 48px);
    max-width: none;
    bottom: 16px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.75rem;
`;

const Message = styled.div`
  flex: 1;
  font-size: 0.95rem;
  line-height: 1.4;
  margin-right: 0.75rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;

const Snackbar = ({ message, onClose, autoHideDuration = 5000 }) => {
  useEffect(() => {
    if (autoHideDuration) {
      const timer = setTimeout(onClose, autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [autoHideDuration, onClose]);

  return (
    <SnackbarContainer>
      <IconWrapper>
        <FiAlertCircle size={20} />
      </IconWrapper>
      <Message>{message}</Message>
      <CloseButton onClick={onClose} aria-label="Close notification">
        <FiX size={20} />
      </CloseButton>
    </SnackbarContainer>
  );
};

export default Snackbar; 